const ClipboardCopy = {
	mounted() {
		this.timer = null;
		this.el.addEventListener("click", () => {
			const text = this.el.getAttribute("data-text");
			const defaultEl = this.el.querySelector(".copy-default");
			const successEl = this.el.querySelector(".copy-success");
			const done = () => {
				if (defaultEl && successEl) {
					defaultEl.classList.add("hidden");
					successEl.classList.remove("hidden");
					if (this.timer) clearTimeout(this.timer);
					this.timer = setTimeout(() => {
						defaultEl.classList.remove("hidden");
						successEl.classList.add("hidden");
					}, 1500);
				}
			};
			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard.writeText(text).then(done).catch(() => this.fallback(text, done));
			} else {
				this.fallback(text, done);
			}
		});
	},
	fallback(text, done) {
		const ta = document.createElement("textarea");
		ta.value = text;
		ta.style.position = "fixed";
		ta.style.opacity = "0";
		document.body.appendChild(ta);
		ta.select();
		try {
			document.execCommand("copy");
		} catch (e) {}
		document.body.removeChild(ta);
		done();
	},
	destroyed() {
		if (this.timer) clearTimeout(this.timer);
	}
};
export default ClipboardCopy;
